import { ColorIndicator } from '../color-indicator';

import { toRem } from '../../utils/ui';
import { conditionalSpread } from '../../utils/helper-utils';

import styles from './color-set.module.scss';

export const ColorSet = (props: ColorSetProps) => {
  const { value, data, onSelect, gap } = props;

  return (
    <div
      className={styles.colorSet}
      style={conditionalSpread(
        {
          ['--gap']: toRem(gap),
        },
        !!gap
      )}
    >
      {data.map((color) => (
        <ColorIndicator key={color} onClick={onSelect} color={color} selected={value === color} />
      ))}
    </div>
  );
};

export interface ColorSetProps {
  gap?: number;
  value: string;
  data: string[];
  onSelect: (value: string) => void;
}
